import React from 'react';
import '../styles/homepage.css';
import Hero from '../componnents/Hero/hero';
import Categories from '../componnents/Categories/Categories';
import Popular from '../componnents/Popular/popular';
import TopBoutiques from '../componnents/TopBoutiques/TopBoutiques';
import RecentlyViewed from '../componnents/RecentlyViewed/RecentlyViewed';
import PromoBanners from '../componnents/PromoBanners/PromoBanners';
import { CampaignCarousel } from '../componnents/Campaigns';

const Shop = () => {
  return (
    <div className="shop-page">
      <Hero />
      <div className="container" style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 1rem' }}>
        <CampaignCarousel />
      </div>
      <Categories />
      <Popular />
      <TopBoutiques limit={5} />
      <RecentlyViewed limit={8} />
      <PromoBanners />
    </div>
  );
};

export default Shop;
